<div class="error-prompt-wrapper" [style]="backgroundStyle">
  <ng-content></ng-content>
</div>
